import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { NgbModal, NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { map, Observable } from 'rxjs';
import { DataTemplate } from '../models/data-template.model';
import { OfferService } from '../services/offer.service';
import { LoadingComponent } from '../shared/spinner/loading/loading.component';
import { TemplateInputModalComponent } from '../template-input-modal/template-input-modal.component';

@Component({
  selector: 'app-template-selector',
  templateUrl: './template-selector.component.html',
  styleUrls: ['./template-selector.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    NgbModalModule,
    NgbTooltipModule,
    LoadingComponent,
  ]
})
export class TemplateSelectorComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly offerService = inject(OfferService);
  private readonly modalService = inject(NgbModal);
  private readonly destroyRef = inject(DestroyRef);

  @ViewChild('stepper') private readonly stepper!: MatStepper;
  newOfferForm: FormGroup = new FormGroup({
    area: new FormControl('', {
      validators: [Validators.required],
    }),
    subArea: new FormControl('', {
      validators: [Validators.required],
    }),
  });
  data: any;
  offerParamsForm$: Observable<string[]> = this.offerService.getOfferDetails().pipe(
    map((data) => {
      this.data = data;
      return Object.keys(data);
    })
  );

  subAreaOptions: any[] = [];

  ngOnInit(): void {
    this.newOfferForm.get('area').valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((area: string) => {
      this.subAreaOptions = this.data[area];
      this.newOfferForm.get('subArea').setValue('', { emitEvent: false });
    });
    this.newOfferForm.get('subArea').valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((_: string) => {
      this.sendTemplateData();
    });
  }

  skipSecondStep() {
    this.stepper.next();
  }

  sendTemplateData() {
    const dataTemplate: DataTemplate = this.newOfferForm.get('subArea')!.value;

    const modalRef = this.modalService.open(TemplateInputModalComponent, {
      size: 'xl',
      scrollable: true,
      backdrop: 'static',
    });
    modalRef.componentInstance.dataTemplate = dataTemplate;

    modalRef.closed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (quoteId: string) =>
        quoteId &&
        this.router.navigate(['/dashboard'], {
          queryParams: { quoteId },
        })
    );
  }

  createOpportunity() {
    this.router.navigate(['/opportunity'], {});
  }
}
